import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=0fa76c54&scoped=true"
import script from "./CreateUserDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateUserDialog.vue?vue&type=style&index=0&id=0fa76c54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa76c54",
  null
  
)

export default component.exports